// extracted by css-extract-rspack-plugin
export default {"PageTitle":"Settings_PageTitle__n5hFE","Wrapper":"Settings_Wrapper__5qMvS"};